import React, { useEffect, useState } from "react";
import { Card, Badge, Row, Col } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";

import ach from "../../assets/BugBountyImages/achivement.png";
import flash from "../../assets/BugBountyImages/flash.png";
import ENDPOINT from "../../data/ENDPOINT";
import { Alert, Avatar } from "@mui/material";
import { Link } from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import SecurityHeaders from "../../data/SecurityHeaders";
import { bottom } from "@popperjs/core";

// --- Enhanced Internal CSS (from Code 2) ---
const styles = {
  heroSection: {
    padding: "50px 0 50px 0",
    background: "linear-gradient(135deg, #f5faff 0%, #eef5ff 100%)",
    overflow: "hidden",
    position: "relative",
  },
  achievementIcon: {
    width: "36px",
    height: "36px",
    padding: "4px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    bottom: "10px",
    position: "absolute",
  },

  title: {
    fontSize: "2.6rem",
    fontWeight: 800,
    color: "#002b56",
    lineHeight: 1.2,
    marginBottom: "18px",
    letterSpacing: "-0.5px",
  },
  subtitle: {
    color: "#007bff",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "2.5px",
    fontSize: "0.9rem",
    marginBottom: "12px",
    opacity: 0.9,
  },
  featureText: {
    color: "#2d3748",
    fontWeight: 600,
    marginRight: "24px",
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
    fontSize: "1.02rem",
    transition: "color 0.3s ease",
  },
  featureIcon: {
    color: "#007bff",
    marginRight: "10px",
    fontSize: "1.3rem",
  },
  mentorCard: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "18px 16px",
    textAlign: "left",
    boxShadow: "0 8px 25px rgba(0, 51, 102, 0.08)",
    transition: "all 0.3s ease",
    border: "1px solid rgba(0, 123, 255, 0.1)",
    cursor: "default",
    height: "100%",
  },
  mentorTitle: {
    fontSize: "1.15rem",
    fontWeight: 700,
    color: "#007bff",
    marginBottom: "6px",
  },
  mentorSubtitle: {
    fontSize: "0.92rem",
    color: "#6c757d",
    fontWeight: 500,
    margin: 0,
  },
  statsCard: {
    backgroundColor: "#ffffff",
    borderRadius: "18px",
    padding: "22px 16px",
    textAlign: "center",
    boxShadow: "0 12px 35px rgba(0, 51, 102, 0.1)",
    backdropFilter: "blur(8px)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    transition: "all 0.3s ease",
  },
  statsNumber: {
    fontSize: "2.1rem",
    fontWeight: 800,
    color: "#ff6b35",
    marginBottom: "4px",
    background: "linear-gradient(90deg, #ff6b35, #f7931e)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  statsText: {
    color: "#555d73",
    marginTop: "4px",
    fontWeight: 600,
    fontSize: "0.95rem",
    letterSpacing: "0.3px",
  },
  imageStyle: {
    maxWidth: "78%",
    height: "auto",
    borderRadius: "24px",
    objectFit: "cover",
    boxShadow: "0 20px 50px rgba(0, 0, 0, 0.12)",
    transition: "all 0.4s ease",
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
  },
  decorCircle: {
    position: "absolute",
    borderRadius: "50%",
    background: "rgba(0, 123, 255, 0.08)",
    zIndex: 0,
  },
  mentorProfileCard: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "20px",
    textAlign: "center",
    boxShadow: "0 8px 25px rgba(0, 51, 102, 0.08)",
    transition: "all 0.3s ease",
    border: "1px solid rgba(0, 123, 255, 0.1)",
    position: "relative",
    overflow: "hidden",
  },
  cardHeaderBg: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "70px",
    background: "linear-gradient(135deg, #007bff, #0056b3)",
    borderRadius: "16px 16px 0 0",
  },
  profileImg: {
    position: "relative",
    width: "90px",
    height: "90px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "4px solid #fff",
    marginLeft: "20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  },
  badgeAvailable: {
    backgroundColor: "#000",
    color: "#fff",
    fontSize: "0.70rem",
    padding: "5px 11px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: 700,
    boxShadow: "0 4px 14px rgba(2,6,23,0.12)",
    bottom: "10px",
    position: "absolute",
  },
  achievementIcon: {
    width: "40px",
    height: "40px",
    padding: "6px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
    border: "1px solid rgba(0,0,0,0.06)",
  },
};

function MentorsPage() {
  const [mentors, setMentors] = useState([]);

  const mentor = async () => {
    const data = new FormData();
    const res = await axios.get(
      ENDPOINT + "fetch-mentors.php",
      data,
      SecurityHeaders
    );
    if (res) {
      console.log(res.data.mentors);
      setMentors(res.data.mentors);
    }
  };

  useEffect(() => {
    mentor();
  }, []);

  return (
    <>
      {/* === Hero Section (from Code 2) === */}
      <div style={styles.heroSection}>
        <div
          style={{
            ...styles.decorCircle,
            width: "500px",
            height: "500px",
            top: "-200px",
            right: "-150px",
          }}
        />
        <div
          style={{
            ...styles.decorCircle,
            width: "300px",
            height: "300px",
            bottom: "-100px",
            left: "-100px",
          }}
        />

        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <Row className="align-items-center">
            {/* Content Column */}
            <Col lg={6} className="text-lg-start text-center mb-5 mb-lg-0">
              <h1 style={styles.title}>
                Get Mentorship From Our Top Mentors & Get employed by renowned
                MNC's
              </h1>
              <p style={styles.subtitle}>
                Explore exciting career opening at industry-leading satrtups
                known for inovation and growth. join a dynamic team and be a
                part of ground breaking
              </p>

              {/* Features */}
              <div className="d-flex flex-column flex-sm-row justify-content-lg-start justify-content-center mb-4">
                <span style={styles.featureText}>
                  <CheckCircleFill style={styles.featureIcon} /> Get Certified
                </span>
                <span style={styles.featureText}>
                  <CheckCircleFill style={styles.featureIcon} /> Get Job-ready
                  Skills
                </span>
                <span style={styles.featureText}>
                  <CheckCircleFill style={styles.featureIcon} /> Great Life
                </span>
              </div>

              {/* Mentor Category Cards */}
              <div className="d-flex flex-wrap justify-content-lg-start justify-content-center col-12">
                {[
                  { title: "Cyber Security", count: "128+" },
                  { title: "Software Development", count: "92+" },
                  { title: "Data Science", count: "62+" },
                  { title: "Human Resource", count: "70+" },
                ].map((item, idx) => (
                  <div key={idx} className="p-2 col-6">
                    <div style={styles.mentorCard}>
                      <h4 style={styles.mentorTitle}>{item.title}</h4>
                      <p style={styles.mentorSubtitle}>
                        {item.count} mentors available
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>

            {/* Image & Stats Column */}
            <Col lg={6} className="position-relative">
              <img
                src="https://i.pinimg.com/1200x/fd/96/24/fd9624ae8ebf666a6661ff666fa06c45.jpg"
                alt="Happy Student"
                style={styles.imageStyle}
                className="img-fluid"
              />

              {/* Floating Stats */}
              <Card
                className="position-absolute d-none d-md-block"
                style={{
                  ...styles.statsCard,
                  top: "-40px",
                  left: "-15px",
                  width: "170px",
                }}
              >
                <p style={styles.statsNumber}>16500+</p>
                <p style={styles.statsText}>Happy Students</p>
              </Card>
              <Card
                className="position-absolute d-none d-md-block"
                style={{
                  ...styles.statsCard,
                  bottom: "-40px",
                  right: "-10px",
                  width: "170px",
                }}
              >
                <p style={styles.statsNumber}>7500+</p>
                <p style={styles.statsText}>Online Video Courses</p>
              </Card>

              {/* Mobile Stats */}
              <div className="d-md-none mt-5 text-center">
                <Row className="g-3">
                  <Col xs={6}>
                    <Card style={styles.statsCard}>
                      <p style={styles.statsNumber}>16500+</p>
                      <p style={styles.statsText}>Happy Students</p>
                    </Card>
                  </Col>
                  <Col xs={6}>
                    <Card style={styles.statsCard}>
                      <p style={styles.statsNumber}>7500+</p>
                      <p style={styles.statsText}>Video Courses</p>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* === Mentor Cards Section (Modernized) === */}
      <div className="container mt-5 pb-5 mb-5">
        <div className="text-center mb-5">
          <h2 style={{ fontWeight: 800, color: "#002b56" }}>
            Get Mentorship From Our Top Mentors
          </h2>
        </div>

        <Row className="mt-3 g-4">
          {mentors.length > 0 ? (
            mentors.map((mentor, index) => (
              <Col key={index} lg={3} md={4} sm={6}>
                <div style={styles.mentorProfileCard}>
                  <div style={styles.cardHeaderBg}></div>

                  <div
                    style={{
                      position: "absolute",
                      top: 12,
                      left: 12,
                      right: 12,
                      zIndex: 3,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      paddingRight: 6,
                    }}
                  >
                   
                    <img
                      // src={ach}
                      // alt="achievement"
                      // style={styles.achievementIcon}
                    />
                     <span style={styles.badgeAvailable}>
                      <img
                        src={flash}
                        alt="flash"
                        style={{ width: 16, height: 16, borderRadius: 999 }}
                      />
                      Available
                    </span>
                    <img
                      src={ach}
                      alt="achievement"
                      style={styles.achievementIcon}
                    />
                  </div>

                  <img
                    src={mentor.profile_pic}
                    alt={`${mentor.first_name}'s profile`}
                    style={styles.profileImg}
                  />

                  <div className="mt-3">
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <h5 className="m-0 fw-bold" style={{ color: "#002b56" }}>
                        {mentor.first_name} {mentor.last_name}
                      </h5>
                      <Badge bg="" className="text-black">
                        ⭐ {mentor.ratings}
                      </Badge>
                    </div>
                    <p
                      className="mt-2 text-muted small"
                      style={{ lineHeight: 1.5 }}
                    >
                      {mentor.bio}
                    </p>
                  </div>

                  {/* Optional: Uncomment if you want View Profile button */}
                  <Link
                    to={`/mentor/${mentor.mentor_id}`}
                    className="btn btn-outline-primary rounded-pill mt-3"
                  >
                    View Profile
                  </Link>
                </div>
              </Col>
            ))
          ) : (
            <p className="text-center mt-3 text-muted">No mentors available.</p>
          )}
        </Row>
      </div>
    </>
  );
}

export default MentorsPage;
